<template>
  <div class="page_container" v-loading="loading">

    <div class="flex_js_wrap">
      <div class="exhibition_left">
        <div class="title">展项分类</div>
        <ul>
          <draggable v-model="categoryList"  @start="handleDraggableStart" @end="handleDraggableEnd">
            <transition-group>
              <li @click.stop="handleClickCateGory(item)"  v-for="(item,key) in categoryList" :key="key" :class="activeCateGory.id == item.id ? 'active' : ''">
                <p v-text="item.category_name"></p>
                <div>
                  <span @click.stop="handleClickEditClassify(item)"><i class="el-icon-edit"></i></span>
                  <span  @click.stop="handleClickDelClassify(item)"><i class="el-icon-delete"></i></span>
                </div>
              </li>
            </transition-group>
          </draggable>
        </ul>
        <div class="add_classify"  @click="handleClickAddClassify()">
          新增分类
        </div>
      </div>
      <div class="exhibition_right">
        <div class="add_btn_wrap">
          <el-button @click="handleClickAdd" icon="el-icon-plus" size="small" type="primary">
            新增展项
          </el-button>
        </div>
        <div class="draggable">
          <el-table :data="tableData" border :height="tableHeight" >
            <!--            <el-table-column   label="编号" prop="id" align="center" width="100" show-overflow-tooltip></el-table-column>-->
            <el-table-column label="展项标题" prop="title" align="center" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="封面" prop="phone" align="center" min-width="120" show-overflow-tooltip>
              <template slot-scope="{row}">
                <img :src="row.cover_image" alt="" widht="50" height="50" style="display: block;object-fit: cover;margin: 0 auto">
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="90">
              <template slot-scope="{row}">
                <el-button type="text"  @click="handleClickEdit(row)">
                  <i class=" el-icon-edit"></i>
                </el-button>
                <el-button type="text"  @click="handleClickDel(row)">
                  <i class="el-icon-delete"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>




  </div>
</template>
<script>
import {getTableStateHeight} from '@/utils'
import {pagination} from '@/mixins'
import {exhibitionProjectDel, exhibitionProjectList, exhibitionProjectSort,exhibitionCategoryList,exhibitionCategoryAdd,exhibitionCategoryEdit,exhibitionCategoryDel} from '@/api'
import draggable from 'vuedraggable'
import Sortable from 'sortablejs';
import {exhibitionCategorySort} from "../../../api";
export default {
  name: 'exhibition_management',
  mixins: [pagination],
  components: {
    draggable
  },
  data() {
    return {
      keyWord: '',
      tableData: [],
      tableHeight: undefined,//table高度
      loading: false,//加载动画
      resizeTimer: null, //节流定时器
      exhibitionVisible:false,
      categoryList:[],
      activeCateGory:null

    }
  },
  mounted() {
    this.tableHeight = getTableStateHeight('page_container', 'el-form', 70)
    this.getExhibitionCategoryList()
    // this.getTableData()
    window.onresize = () => {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      //开启定时器，节流函数
      this.resizeTimer = setTimeout(() => {
        //将计算的table高度赋值给table
        this.tableHeight = getTableStateHeight('page_container', 'el-form', 90)
        //清除定时器
        this.resizeTimer = null
      }, 70)
    }
    this.rowDrop()
  },
  methods: {
    // 获取展项分类
    getExhibitionCategoryList(){
      this.loading = true
      let postData = {  }
      exhibitionCategoryList(postData).then(res => {
        if (res.code === 200) {
          this.categoryList = res.data
          if(!this.activeCateGory &&  res.data.length > 0){
            this.activeCateGory = res.data[0]
          }
          this.getTableData()
        }
        this.loading = false
      })
    },
    handleDraggableStart(){

    },
    handleDraggableEnd(){
      let info = this.categoryList.map((item,key)=>{
        return {id:item.id,sort:key}
      })
      let postData = {
        data:info
      }
      exhibitionCategorySort(postData).then(res => {
        if (res.code === 200) {

        }
      })
    },
    // 选中分类
    handleClickCateGory(item){
      this.activeCateGory = item
      this.getTableData()
    },
    // 新增分类
    handleClickAddClassify(){
      this.$prompt('分类名称', '新增分类', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal:false,
        inputPattern: /\S/,
        inputErrorMessage: '请输入'
      }).then(({ value }) => {
        let postData = {
          category_name:value,
          sort:Math.max(...this.categoryList.map(item => item.sort)) + 1
        }
        exhibitionCategoryAdd(postData).then(res => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: '新增成功',
              type: 'success',
              duration: 1500,
              onClose: () => {}
            });
            this.getExhibitionCategoryList()
          }
        })
      }).catch(() => {

      });
    },
    // 编辑分类
    handleClickEditClassify(item){
      this.$prompt('分类名称', '编辑分类', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal:false,
        inputPattern: /\S/,
        inputValue: item.category_name,
        inputErrorMessage: '请输入'
      }).then(({ value }) => {
        let postData = {
          category_name:value,
          sort:item.sort,
          id:item.id
        }
        exhibitionCategoryEdit(postData).then(res => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: '编辑成功',
              type: 'success',
              duration: 1500,
              onClose: () => { }
            });
            this.getExhibitionCategoryList()
          }
        })
      }).catch(() => {

      });
    },
    // 删除分类
    handleClickDelClassify(item){
      this.$confirm('删除分类后，该分类下的展项将一并删除，不可恢复！请谨慎操作！', '提示', {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'error'
      }).then(() => {
        let postData = {
          id:item.id
        }
        exhibitionCategoryDel(postData).then(res => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
              }
            });
            this.getExhibitionCategoryList()
          }
        })
      }).catch(() => {
        return false
      })
    },
    // 行拖拽
    rowDrop() {
      // 此时找到的元素是要拖拽元素的父容器
      const tbody = document.querySelector('.draggable .el-table__body-wrapper tbody');
      const _this = this;
      Sortable.create(tbody, {
        //  指定父元素下可被拖拽的子元素
        draggable: ".draggable .el-table__row",
        onEnd: evt => {
          let data = JSON.parse(JSON.stringify(_this.tableData))
          let sortArray = []
          data.forEach((item, key) => {
            sortArray.push(item.sort)
          })
          sortArray.sort((a, b) => b - a); //排序
          const targetRow =  data.splice(evt.oldIndex, 1)[0]
          data.splice(evt.newIndex, 0, targetRow)
          data.forEach((item, index) => {
            this.$set(item,'sort',sortArray[index])
          })
          let info = data.map((item,key)=>{
            return {id:item.id,sort:key}
          })
          _this.setExhibitionProjectSort(info)
        }
      });
    },

    setExhibitionProjectSort(info){
      this.loading = true
      let postData = {
        data:info
      }
      exhibitionProjectSort(postData).then(res => {
        if (res.code === 200) {
          this.getTableData()
        }
        this.loading = false
      })
    },

    getTableData() {
      this.loading = true
      this.$set(this,'tableData',[])
      let postData = {
        category_id:this.activeCateGory.id
      }
      exhibitionProjectList(postData).then(res => {
        if (res.code === 200) {
          const { data, } = res
          this.$set(this,'tableData',data)
        }
        this.loading = false
      })
    },

    handleClickAdd(){
      this.$router.push({name:'exhibition_tpl',query:{ category_id:this.activeCateGory.id}});

    },

    handleClickEdit(row){
      this.$router.push({name:'exhibition_tpl',query:{id:row.id}});
    },

    handleClickDel(row){
      this.$confirm('删除展项后不可恢复！请谨慎操作！', '提示', {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'error'
      }).then(() => {
        exhibitionProjectDel({
          id:row.id
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getTableData()
          }
        })
      }).catch(() => {
        return false
      })
    },


    handleSizeChange(val) {
      this.pagination.pageNum = 1
      this.pagination.pageSize = val
      this.getTableData()
    },

    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.getTableData()
    },

  },
}
</script>
<style lang="scss" scoped>
.add_btn_wrap {
  padding: 0 0 12px 0;
  text-align: right;
}
.page_container{
  padding: 0;
}
.exhibition_left{
  width: 220px;
  min-width: 220px;
  height: calc(100vh - 140px);
  border-right: 1px solid #ebeef5;
  box-sizing: border-box;
  .title{
    line-height: 56px;
    height: 56px;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
  }
  ul{
    width: 100%;
    height: calc(100% - 106px);
    overflow: auto;
    padding: 8px;
    box-sizing: border-box;
    li{
      width: 100%;
      margin-bottom: 8px;
      padding: 0 40px 0 8px;
      box-sizing: border-box;
      border-radius: 4px;
      background: #fff;
      line-height: 30px;
      height: 30px;
      position: relative;
      cursor: pointer;
      &.active{
        background: rgba(25, 144, 255, 0.16);
      }
      &:hover{
        background: rgba(0, 0, 0, 0.04);
        div{
          display: flex;
        }
      }
      p{

      }
      div{
        position: absolute;
        right: 8px;
        width: 32px;
        top: 0;
        justify-content: space-between;
        display: none;
        span{
          i{
            font-size: 14px;
            &:hover{
              color: #1990ff;
            }
          }
        }
      }
    }
  }
  .add_classify{
    width: calc(100% - 24px);
    height: 32px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12);
    text-align: center;
    line-height: 32px;
    border: 1px solid #e8e8e8;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    cursor: pointer;
    margin: 0 auto;
  }

}
.exhibition_right{
  padding:16px  16px 0 0;
  width: calc(100% - 220px);
  height: 100%;
  box-sizing: border-box;
  .draggable{
    padding: 0px 0 0px 16px;
  }
}
</style>
